const INWARDAPI = {
    ADDINWARD: `bill/`,
    GETCLIENTS: `clients/clients`,
    GETALLBILL: `bill/clients/bill/all`,
    SPECIFIC_CLIENT_BILL: (billId, clientId)  =>  `bill/${billId}/client/${clientId}`
}

export default INWARDAPI;